var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2481,
    height: 2073,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orange pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg_3_blur",
    width: "200%",
    height: "200%",
    y: "-50%",
    x: "-50%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    clipRule: "evenodd",
    fill: "#52c41a",
    fillRule: "evenodd",
    strokeMiterlimit: 10,
    strokeWidth: 37,
    d: "m730.940002,1839.630005c-38.765991,-190.300049 -107.116028,-348.670044 -189.903015,-495.440063c-61.406982,-108.869995 -132.543976,-209.359985 -198.363983,-314.939941c-21.972015,-35.242981 -40.93399,-72.476013 -62.046997,-109.052979c-42.216003,-73.137024 -76.444,-157.934998 -74.269012,-267.932007c2.125,-107.473022 33.208008,-193.684021 78.029999,-264.172028c73.718994,-115.934998 197.201019,-210.988983 362.884003,-235.968994c135.466003,-20.423996 262.474976,14.082001 352.54303,66.748001c73.596008,43.03801 130.596008,100.526993 173.915955,168.280014c45.219971,70.716003 76.359985,154.259979 78.969971,263.231964c1.340088,55.830017 -7.799927,107.532043 -20.679932,150.41803c-13.030029,43.408997 -33.98999,79.695007 -52.640015,118.453979c-36.410034,75.658997 -82.050049,144.984009 -127.859985,214.343994c-136.437012,206.609985 -264.496033,417.310059 -320.580017,706.030029z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_4",
    clipRule: "evenodd",
    fill: "#000000",
    fillRule: "evenodd",
    cx: 729.546,
    cy: 651.047,
    r: 183.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    opacity: 0.25,
    clipRule: "evenodd",
    fill: "black",
    fillRule: "evenodd",
    d: "m731.379028,1838.955444c131.603943,-120.869995 211.313965,-235.97998 269.140991,-350.48999c42.890015,-84.950073 70.540039,-169.170044 106.949951,-254.060059c12.160034,-28.339966 28.51001,-56.569946 42.52002,-85.299927c28.02002,-57.450073 72.660034,-118.140015 169.030029,-178.100037c94.160034,-58.589966 193.949951,-93.755981 291.579956,-114.69696c160.560059,-34.442017 344.280029,-37.299011 502.589966,15.593018c129.449951,43.243958 204.680176,113.463928 233.780029,178.863892c23.780029,53.440063 21.429932,108.180054 -1.040039,163.099976c-23.459961,57.320068 -69.569824,116.070068 -161.109863,177.390015c-46.900146,31.420044 -98.900146,56.340088 -146.410034,74.869995c-48.090088,18.76001 -96.599976,30.390015 -145.330078,44.320068c-95.119995,27.189941 -192.419922,47.150024 -289.890015,67.079956c-290.319946,59.339966 -577.25,124.320068 -871.810913,261.430054z",
    filter: "url(#svg_3_blur)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerGreen);
export default __webpack_public_path__ + "static/media/map-marker-green.dae6b12604cd20c0a2b4f9df66dd809c.svg";
export { ForwardRef as ReactComponent };